import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '@/app/store/auth.store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, checkSessionExpiry } = useAuthStore();

  // Check session expiry on mount and periodically
  useEffect(() => {
    // Check immediately
    checkSessionExpiry();

    // Check every 5 minutes
    const interval = setInterval(() => {
      checkSessionExpiry();
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, [checkSessionExpiry]);

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
